export default "/images/380c1c7157426c0d46fbeaa44a0d8931.png";